import React, { useState } from "react";
import "../css-dashboard/Dashboard.css";
import SidebarTraveler from "../../components/sidebar-dashboard/SidebarTraveler";
import TravelerTripsConcludedNegotiations from "../../components/traveler-trips-negotiations/TravelerTripsConcludedNegotiations";
import UseTravelerTripsNegotiations from "../../hooks/UseTripsNegotiations/UseTravelerTripsNegotiations";
import UseModalReceiverData from "../../hooks/UseModalReceiverData/UseModalReceiverData";
import ModalReceiverData from "../../components/modal-receiver-data/ModalReceiverData";

const TripsConcludedTraveler = ({ menuOpen, setMenuOpen }) => {
  const {
    tripsNegotiations,
    loadingTripsNegotiations,
    refetchTripsNegotiations,
  } = UseTravelerTripsNegotiations();

  const {
    isOpenReceiverData,
    showSuccessScreenReceiverData,
    openModalReceiverData,
    closeModalReceiverData,
    selectedNegotiationReceiverData,
    formDataReceiverData,
    handleChange,
    handlePhoneChange,
    handleBlur,
    handleSubmit,
    loadingReceiverData,
    errorReceiverData,
    successReceiverData,
    errorsReceiverData,
  } = UseModalReceiverData(() => {
    refetchTripsNegotiations();
  });

  return (
    <>
      <div className={`dashboard-container ${menuOpen ? "menu-open" : ""}`}>
        <SidebarTraveler menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

        <main className="main-content">
          <div className="dashboard-header">
            <h1>Dashboard do Viajante</h1>
            <p className="breadcrumb">
              <a href="/dashboard-traveler">Início</a> / Viagens Realizadas
            </p>
          </div>

          <TravelerTripsConcludedNegotiations
            tripsNegotiations={tripsNegotiations}
            loadingTripsNegotiations={loadingTripsNegotiations}
            onOpenReceiverModal={openModalReceiverData}
          />
        </main>
      </div>

      <ModalReceiverData
        isOpenReceiverData={isOpenReceiverData}
        showSuccessScreenReceiverData={showSuccessScreenReceiverData}
        closeModalReceiverData={closeModalReceiverData}
        formDataReceiverData={formDataReceiverData}
        handleChange={handleChange}
        handlePhoneChange={handlePhoneChange}
        handleBlur={handleBlur}
        handleSubmit={handleSubmit}
        loadingReceiverData={loadingReceiverData}
        errorReceiverData={errorReceiverData}
        errorsReceiverData={errorsReceiverData}
        successReceiverData={successReceiverData}
        selectedNegotiationReceiverData={selectedNegotiationReceiverData}
      />
    </>
  );
};

export default TripsConcludedTraveler;
